export default function confirmQr(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'CONFIRM_QR_SUCCESS':
      return {...state, ...{success: action.success,error:null}};
    case 'CONFIRM_QR_ERROR':
      return {...state, ...{error: action.error.response,success:null}};
    case 'CONFIRM_QR_PROCESSING':
      return {...state, ...{processing: action.processing}};
    default:
      return state;
  }
}
